<template>
    <div>
        <ContentExcerciseNotScore_Word_PDF
            v-if="dataLesson.typeUploadExcercise == 4 || dataLesson.typeUploadExcercise == 6" />
        <ContentExcerciseNotScore_Bank v-if="dataLesson.typeUploadExcercise == 2" />
    </div>
</template>
<script>
import { getDetail } from './../../_api/LessonClassSchoolServices'
import ContentExcerciseNotScore_Word_PDF from './_components/ContentExcerciseNotScore_Word_PDF'
import ContentExcerciseNotScore_Bank from './_components/ContentExcerciseNotScore_Bank'
export default {
    components: {
        ContentExcerciseNotScore_Word_PDF,
        ContentExcerciseNotScore_Bank
    },
    data() {
        return {
            lessonClassSchoolId: 0,
            classSchoolId: 0,
            dataLesson: {}
        }
    },
    mounted() {
        this.lessonClassSchoolId = this.$route.query.id
        this.classSchoolId = this.$route.query.classSchoolId
        this.getDetailLesson()
    },
    methods: {
        getDetailLesson() {
            getDetail(this.lessonClassSchoolId).then((res) => {
                if (res && res.data && !res.errors) {
                    this.dataLesson = res.data
                }
            })
        }
    }
}
</script>